export enum Fonts {
  Poppins = 'Poppins',
  Roboto = 'Roboto',
  Tajawal = 'Tajawal',
  Gotham = 'Gotham',
  Frutiger = 'Frutiger',
  Raleway = 'Raleway',
  CorpidCdLFHeavy = 'CorpidCdLFHeavy',
  Futura = 'Futura',
  Swiss = 'Swiss',
  Tungsten = 'Tungsten',
  Avenir = 'Avenir',
  Mukta = 'Mukta',
  Nunito = 'Nunito',
  Montserrat = 'Montserrat',
  NanumGothic = 'NanumGothic',
  Oswald = 'Oswald',
  PlayfairDisplay = 'PlayfairDisplay',
  Ubuntu = 'Ubuntu',
  Lora = 'Lora',
  Melbourne = 'Melbourne',
  Aeonik = 'Aeonik',
  Dtl = 'Dtl',
  Barlow = 'Barlow',
  CharlevoixPro = 'CharlevoixPro',
  JosefinSans = 'JosefinSans',
  Univers = 'Univers'
}

export enum FontFamily {
  Poppins = 'Poppins',
  Roboto = 'Roboto',
  Futura = 'Futura',
  Tajawal = 'Tajawal',
  Gotham = 'Gotham',
  Frutiger = 'Frutiger',
  Raleway = 'Raleway',
  CorpidCdLFHeavy = 'Corpid Cd LF',
  Swiss = 'Swiss',
  Lora = 'Lora',
  Tungsten = 'Tungsten',
  Avenir = 'Avenir',
  Mukta = 'Mukta',
  Nunito = 'Nunito',
  Montserrat = 'Montserrat',
  NanumGothic = 'Nanum Gothic',
  Oswald = 'Oswald',
  PlayfairDisplay = 'Playfair Display',
  Ubuntu = 'Ubuntu',
  Melbourne = 'Melbourne',
  Dtl = 'Dtl',
  Barlow = 'Barlow',
  Aeonik = 'Aeonik',
  CharlevoixPro = 'Charlevoix Pro',
  JosefinSans = 'JosefinSans',
  Univers = 'Univers'
}

export const FontStyleSheet: Record<Fonts, string> = {
  Poppins: 'https://static.gamiphy.co/assets/fonts/poppins/stylesheet.css',
  Roboto: 'https://static.gamiphy.co/assets/fonts/roboto/stylesheet.css',
  Frutiger: 'https://static.gamiphy.co/assets/fonts/frutiger/stylesheet.css',
  Futura: 'https://static.gamiphy.co/assets/fonts/futura/stylesheet.css',
  Gotham: 'https://static.gamiphy.co/assets/fonts/gotham/stylesheet.css',
  Raleway: 'https://static.gamiphy.co/assets/fonts/raleway/stylesheet.css',
  Tajawal: 'https://static.gamiphy.co/assets/fonts/tajawal/stylesheet.css',
  CorpidCdLFHeavy: 'https://static.gamiphy.co/assets/fonts/corpidCdLF/corpidstylesheet.css',
  Swiss: 'https://static.gamiphy.co/assets/fonts/swiss/stylesheet.css',
  Tungsten: 'https://static.gamiphy.co/assets/fonts/tungsten/stylesheet.css',
  Avenir: 'https://static.gamiphy.co/assets/fonts/avenir/stylesheet.css',
  Mukta: 'https://static.gamiphy.co/assets/fonts/mukta/stylesheet.css',
  Nunito: 'https://static.gamiphy.co/assets/fonts/nunito/stylesheet.css',
  Montserrat: 'https://static.gamiphy.co/assets/fonts/montserrat/stylesheet.css',
  NanumGothic: 'https://static.gamiphy.co/assets/fonts/nanum-gothic/stylesheet.css',
  Oswald: 'https://static.gamiphy.co/assets/fonts/oswald/stylesheet.css',
  PlayfairDisplay: 'https://static.gamiphy.co/assets/fonts/playfair-display/stylesheet.css',
  Ubuntu: 'https://static.gamiphy.co/assets/fonts/ubuntu/stylesheet.css',
  Lora: 'https://static.gamiphy.co/assets/fonts/lora/stylesheet.css',
  Melbourne: 'https://static.gamiphy.co/assets/fonts/melbourne/stylesheet.css',
  Dtl: 'https://static.gamiphy.co/assets/fonts/dtl/stylesheet.css',
  Barlow: 'https://static.gamiphy.co/assets/fonts/barlow/stylesheet.css',
  Aeonik: 'https://static.gamiphy.co/assets/fonts/aeonik-2/stylesheet.css',
  CharlevoixPro: 'https://static.gamiphy.co/assets/fonts/CharlevoixPro/stylesheet.css',
  JosefinSans: 'https://static.gamiphy.co/assets/fonts/josefin-sans/stylesheet.css',
  Univers: 'https://static.gamiphy.co/assets/fonts/univers/stylesheet.css',
};
